import React from "react"
import { Box } from "@chakra-ui/react"
import { Email } from "sharedTypes"
import BlockContent from "./Builder/BlockContent"
import EmailFooter from "./EmailFooter"

type Props = {
  email: Email
}

const ViewEmailContent = ({
  email: {
    showUnsubscribe,
    backgroundColor,
    borderColor,
    emailData: { blocks },
    emailAttachment: { fileName },
  },
}: Props) => (
  <Box bgColor={backgroundColor} py={10}>
    <Box borderWidth={1} borderColor={borderColor} w={600} mx="auto" mb={2}>
      {blocks.map((block, index) => <BlockContent key={index} block={block} />)}
    </Box>
    <EmailFooter attachmentFileName={fileName} showUnsubscribe={showUnsubscribe} />
  </Box>
)

export default ViewEmailContent
